import axios from "axios";
import {createAction} from "redux-actions";
import {normalize} from "normalizr";
import queryString from "../functions/queryString";

export default config => {

    const actions = {
        begin: createAction(config.type + '_BEGIN'),
        request: createAction(config.type + '_REQUEST', async props => {
            let url, method;
            if (props.url) {
                url = props.url
            } else if (typeof config.url === 'function') {
                url = config.url({...config.urlDefaults, ...props.urlParams});
            } else {
                url = config.url;
            }

            const queryParams = {...config.queryDefaults, ...props.queryParams};
            if (0 < Object.keys(queryParams).length) {
                url += '?' + queryString(queryParams);
            }

            if (!!props.method) {
                method = props.method;
            } else if (!!config.method) {
                method = config.method;
            } else {
                method = 'get';
            }

            if (typeof props.headers !== 'object') {
                props.headers = {};
            }

            const headers = {
                ...axios.defaults.headers.common,
                ...config.headers,
                ...props.headers
            };

            config.source = axios.CancelToken.source();
            return axios.request({
                url,
                method,
                headers,
                data: props.data,
                cancelToken: config.source.token,
            }).then(remote => {
                let response;
                if (!!config.schema) {
                    if (headers.Accept === 'application/ld+json' && 'undefined' !== typeof remote.data['hydra:member']) {
                        response = {
                            ...props,
                            count: remote.data['hydra:totalItems'],
                        };
                        if (!!config.schema) {
                            response.normalized = normalize(remote.data['hydra:member'], config.schema);
                        }
                        if (typeof props.map === 'function') {
                            response.items = remote.data['hydra:member'].map(props.map);
                        }
                    } else {
                        response = {
                            ...props,
                            normalized: normalize(remote.data, config.schema),
                            data: remote.data,
                        };
                    }
                } else {
                    response = remote.data;
                }

                return Promise.resolve(response);
            }).catch(error => {
                return Promise.reject({
                    error: error.response ? error.response.data : error,
                });
            });
        }),
        cancel: message => {
            if (config.source) {
                config.source.cancel(message)
            }
        },
        action: props => (dispatch, getState) => {
            if (!props) props = {};
            dispatch(actions.begin(props));
            return new Promise((resolve, reject) => {
                dispatch(actions.request(props))
                    .then(action => resolve(action.payload))
                    .catch(error => reject(error));
            });
        },
    };

    return actions;
};



// WEBPACK FOOTER //
// ./src/actions/remote.js